<template>
    <div class="view">
        <h3>{{title}}</h3>
        <a :href="`${publicPath}pdf/${file}`">Télécharger la notice d'utilisation</a>
    </div>
</template>

<script>

  export default {
    data () {
      return {
        publicPath: process.env.BASE_URL
      }
    },
    computed: {
      title() {
        return this.$route.meta.aide_title;
      },
      file() {
        return this.$route.meta.aide_file;
      }
    }
  }
</script>
